// Some apps configure NEXT_PUBLIC_API_VERSION, so @partment/client bakes the
// version into the axios baseURL and shared endpoints use bare paths
// (e.g. base `.../api/v3` + `/profiles/me/`). Others (e.g. co-owner) leave
// NEXT_PUBLIC_API_VERSION unset and put the version in each request path
// (base `.../api` + `v3/...`). These shared endpoints are all on API v3, so
// prefix the version here only when the app has no NEXT_PUBLIC_API_VERSION —
// yielding `.../api/v3/...` in both setups without changing the version-apps.
export const v3Path = (path: string): string => {
  const clean = path.replace(/^\/+/, '')
  return process.env.NEXT_PUBLIC_API_VERSION ? `/${clean}` : `/v3/${clean}`
}
